// Copyright (c) Docugami, Inc. All rights reserved.

import { Config } from "../../config";
import { getFeatureFlagFromCache } from "./actions";
import { FeatureFlagState, SET_FEATURE_FLAG, FeatureFlags } from "./types";

const initialState: FeatureFlagState = {
    featureFlags: {
        [FeatureFlags.DiagnosticLoggingEnabled]: getFeatureFlagFromCache(FeatureFlags.DiagnosticLoggingEnabled, defaultValue(FeatureFlags.DiagnosticLoggingEnabled, false)),
        [FeatureFlags.DownloadAllPipelineOutput]: getFeatureFlagFromCache(FeatureFlags.DownloadAllPipelineOutput, defaultValue(FeatureFlags.DownloadAllPipelineOutput, false)),
        [FeatureFlags.DemoFeatures]: getFeatureFlagFromCache(FeatureFlags.DemoFeatures, defaultValue(FeatureFlags.DemoFeatures, false)),
        [FeatureFlags.ChunkSourceDebugEnabled]: getFeatureFlagFromCache(FeatureFlags.ChunkSourceDebugEnabled, defaultValue(FeatureFlags.ChunkSourceDebugEnabled, false)),
        [FeatureFlags.DebugTokensEnabled]: getFeatureFlagFromCache(FeatureFlags.DebugTokensEnabled, defaultValue(FeatureFlags.DebugTokensEnabled, false)),
        [FeatureFlags.SdvDebugEnabled]: getFeatureFlagFromCache(FeatureFlags.SdvDebugEnabled, defaultValue(FeatureFlags.SdvDebugEnabled, false)),
        [FeatureFlags.ExperimentalFeatures]: getFeatureFlagFromCache(FeatureFlags.ExperimentalFeatures, defaultValue(FeatureFlags.ExperimentalFeatures, false)),
        [FeatureFlags.ChatFeature]: getFeatureFlagFromCache(FeatureFlags.ChatFeature, defaultValue(FeatureFlags.ChatFeature, true)),
        [FeatureFlags.ChatStreaming]: getFeatureFlagFromCache(FeatureFlags.ChatStreaming, defaultValue(FeatureFlags.ChatStreaming, true)),
        [FeatureFlags.SdvCanvasEditor]: getFeatureFlagFromCache(FeatureFlags.SdvCanvasEditor, defaultValue(FeatureFlags.SdvCanvasEditor, false)),
    }
};

function defaultValue(featureFlag: FeatureFlags, defaultIfNotInConfig: boolean): boolean {
    console.log(Config.featureFlags);
    // @ts-ignore
    const configValue = Config.featureFlags[featureFlag];
    if (configValue !== undefined) {
        return configValue;
    }

    return defaultIfNotInConfig;
}

export function featureFlagsReducer(
    state = initialState,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    action: any
): FeatureFlagState {
    switch (action.type) {
        case SET_FEATURE_FLAG:
            {
                return {
                    ...state,
                    featureFlags: {
                        ...state.featureFlags,
                        [action.payload.featureFlag]: action.payload.value
                    }
                };
            }

        default:
            return state;
    }
}
